import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MarketService } from '../shared/services/market.service';
import { scaleIn } from '../shared/animations/modal.animation';
import { Auth } from 'aws-amplify'; 

@Component({
  selector: 'app-sponsors',
  templateUrl: './sponsors.component.html',
  styleUrls: ['./sponsors.component.css'], 
  animations: [scaleIn]
})
export class SponsorsComponent implements OnInit {

  @Input() visible: boolean; 
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public displayProperty = true;
  public displayViewMore = false;
  public displayFilters = false;
  public propertyDetail: any;
  public propertiesData: any;
  public defaultPropData: any;
  public imageBaseUrl = "https://cherymaupps3gradebookexample.s3.amazonaws.com/";
  public isLoading: boolean;
  imageName = "1200px-SAFA_logo.svg.png";
  public searchText: any;
  public displaySearchText: any = "";
  public searching: boolean;
  public searchResults: boolean;
  public resultsValue: number; 
  public queryArr = [];
  public categories = [];
  public newCategories : Array<{}>;
  public test: boolean;
  public pageName: string = "sponsors";
  public noRecords: boolean = false;
  public displaySponsorsLogin: boolean = false; 
  public displaySponsorsRegister: boolean = false; 
  user: string;
  userGroup: string;
  username: string;
  isHidden: boolean = true;

  constructor(private router: Router, private marketService: MarketService) { 
    this.categories = [
      {id:1,value:'Banking',isSelected:false},
      {id:2,value:'Insurance',isSelected:false},
      {id:3,value:'Government',isSelected:false},
      {id:4,value:'Sport',isSelected:false},
      {id:5,value:'Technology',isSelected:false},
      {id:6,value:'Energy',isSelected:false},
      {id:7,value:'Telecomm.',isSelected:false}, 
      {id:8,value:'Sport Wear',isSelected:false},
      {id:9,value:'Hospitality',isSelected:false},
      {id:10,value:'Beverages',isSelected:false},
      {id:11,value:'Transport',isSelected:false},
      {id:12,value:'Education',isSelected:false}
    ];
	
	this.getCurrentAuthenticatedUser();
  }

  ngOnInit() {
    this.isLoading = true;
    this.searching = false;
    this.searchResults = false;
    this.searchText = '';
    this.displayProperty = true;
    this.isLoading = false;

    // this.user = sessionStorage.getItem('CurrentAuthenticatedUser');
    // this.userGroup = sessionStorage.getItem('UserGroup');
    // console.log("sessionStorage CurrentAuthenticatedUser", this.user);

    // this.getInitProperties();
    this.getTopSearches();
  }
  
  getCurrentAuthenticatedUser(){
    const user = Auth.currentAuthenticatedUser()
      .then((user) => {
		this.username = user.attributes.name+" "+user.attributes.family_name;
        this.isHidden = false;
        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        
        // console.log('Detailed user group data ==> ', user.signInUserSession.accessToken.payload['cognito:groups'][0]); 
        // console.log('header user', user);
        
      },
      (error) =>{
        // console.log("authentication error", error);
        
        this.isHidden = true;
      });
  }

  getTopSearches(){
    const topHitsQuery = {
      "query": {
        "match_all": {}
      },
      "size" : 0,
      "aggs": {
        "topSearches": {
          "top_hits": {
            "size" : 9
          }
        }
      }
    }
    
    this.marketService.onQuerySearch(topHitsQuery, this.pageName).subscribe((data) => {
      this.isLoading = false;
      // console.log("Top Hits", data.aggregations.topSearches.hits.hits);
      
	  this.propertiesData = data.aggregations.topSearches.hits.hits;

      // if(this.user && this.userGroup === "sponsors"){
      //   this.propertiesData = data.aggregations.topSearches.hits.hits;
      // }
      
      if(!this.propertiesData.length){
        this.noRecords = true;
      }else{
        this.noRecords = false;
      }

    },
    (error) => {
      this.noRecords = true;
      // console.log("Top Searches Error", error);
    });
  }

  onView(source: any) {
    this.propertyDetail = source;
    // console.log("Clicked: ",this.propertyDetail);
    this.displayViewMore = true;
  }

  onFilter(){
    this.displayFilters = true;
  }

  getFilters($event){
    this.newCategories = $event;
    // console.log("getFilters: ", this.newCategories);

    this.isLoading = true;
    this.queryArr = this.newCategories;
	
	  const sortQuery = {
      "query": {
        "bool": {
          "should" : this.queryArr,
          "minimum_should_match" : 1,
          "boost" : 1.0
        }
      }
    }

    this.marketService.onQuerySearch(sortQuery, this.pageName).subscribe((data) => {
      this.isLoading = false;
      this.searching = false;

      if(this.queryArr.length === 0){
        this.getTopSearches();
      }
      
      // console.log("Sorting ",data);
      this.propertiesData = data.hits.hits;
    },
    (error) => {
      this.isLoading = false;
      // console.log("Sorting error", error);
    });
  }

  onQuerySearch(){

    const myQuery = {
      "query" : {
        "multi_match" : {
          "query": this.searchText,
          "fields": [ "propName^1", "propDescription" ]
        }
      }
    }

    // console.log("Search word length: ", this.searchText.length);

    // console.log("This is the search result : " + this.searchText); 
      
    
    // this.displaySearchResult = true;
    // console.log("Search Word", this.searchText);
    this.displaySearchText = this.searchText;
    
    if(this.searchText.length !== 0){
      this.isLoading = true;

      this.marketService.onQuerySearch(myQuery, this.pageName).subscribe((data) =>{
        // console.log("Search Results", data);
        //checking for error data
        
        this.searching = true;
        this.isLoading = false;

        this.propertiesData = data.hits.hits;
        this.resultsValue = data.hits.total.value;

        // console.log("Search Results value", this.resultsValue);
        if(this.resultsValue > 0){
          this.searchResults = true;
        }else{
          this.searchResults = false;
        }

        // console.log("searchResults", this.searchResults);
        
      },
      (error) =>{
        this.isLoading = false;
        // console.log("Search Error", error);
        this.propertiesData = [];                //Clear Array is no results found
      });
    }else {
      // console.log("Enter text in the search box");
      this.propertiesData = this.defaultPropData;
    }
  }

  onChecked(event: any){
    this.isLoading = true;
    this.queryArr = this.createQueryArray(event);
	
	  const sortQuery = {
      "query": {
        "bool": {
          "should" : this.queryArr,
          "minimum_should_match" : 1,
          "boost" : 1.0
        }
      }
    }

    

    this.marketService.onQuerySearch(sortQuery, this.pageName).subscribe((data) => {
      this.isLoading = false;
      this.searching = false;

      if(this.queryArr.length === 0){
        this.getTopSearches();
      }
      
      // console.log("Sorting ",data);
      this.propertiesData = data.hits.hits;
    },
    (error) => {
      this.isLoading = false;
      // console.log("Sorting error", error);
    }); 
  }

  createQueryArray(event: any): any[]{
    if(!event.target.checked){
      this.remove(event.target.value);
    }else{
      this.queryArr.push({ "match" : { "type" : event.target.value } });
    }
    return this.queryArr;
  }

  remove(category: any){
    if (this.queryArr !== null){ 
      var size = this.queryArr.length;
       for (var x =0 ; x< size ; x++){
          // console.log ("remove loop: ",this.queryArr [x]);
          if (this.queryArr [x].match.propType == category){
            // console.log("Remove: ",category);
            this.queryArr.splice (x,1);
            break;
          }
       }
    }
    // console.log("queryArr: ", this.queryArr); 
  }

  close() {
    this.visible = false; 
  }

  onDiplaySponsorsLogin() {
    this.displaySponsorsLogin = true; 
  }

  onDiplaySponsorsRegister() {
    this.displaySponsorsRegister = true; 
  }
  
  applySponsor(){
	  this.router.navigateByUrl('/apply');
  }

}
